module.exports = __webpack_public_path__ + "static/media/workAntihumidity6.dca58f3a.jpg";